import { Component } from 'react';
import Scrollbars from 'react-custom-scrollbars-2';
import { connect } from 'react-redux';

import Button from 'components/atoms/Button';
import Form from 'components/atoms/Form';
import Icon from 'components/atoms/Icon';
import Input from 'components/atoms/Input';
import ToggleButton from 'components/atoms/ToggleButton';
import TypeTag from 'components/atoms/TypeTag';
import { RootState, TagType } from 'types';
import { VoidInterface } from 'types/functions';
import { clone } from 'utils/formHandlers';
import { translate } from 'utils/translate';

interface SearchTagsModelProps {
    children?: string | JSX.Element | JSX.Element[];
    language: string;
    id?: string;
    data: any;
    actions:
        | { onCancel: VoidInterface; onConfirm: (selectedTags: number[], withComments: boolean) => void }
        | undefined;
    tags: TagType[];
}

interface SearchTagsModelState {
    tags: TagType[];
    searchTags: TagType[];
    searchQuery: string;
    selectedTags: number[];
    withComments: boolean;
    selectedTagsSource: number[];
    withCommentsSource: boolean;
}

class SearchTagsModel extends Component<SearchTagsModelProps, SearchTagsModelState> {
    constructor(props: SearchTagsModelProps) {
        super(props);
        this.state = {
            withComments: props.data.withComments,
            selectedTags: clone(props.data.selectedTags) || [],
            withCommentsSource: props.data.withComments,
            selectedTagsSource: clone(props.data.selectedTags) || [],
            searchQuery: '',
            tags: props.tags
                .filter((tag: TagType) => {
                    return tag.type === 'private' || tag.type === 'public' || tag.type === 'analysis';
                })
                .sort(function (a, b) {
                    if (a.type.toLowerCase() < b.type.toLowerCase()) return -1;
                    if (a.type.toLowerCase() > b.type.toLowerCase()) return 1;
                    return 0;
                }),
            searchTags: props.tags
                .filter((tag: TagType) => {
                    return tag.type === 'private' || tag.type === 'public' || tag.type === 'analysis';
                })
                .sort(function (a, b) {
                    if (a.type.toLowerCase() < b.type.toLowerCase()) return -1;
                    if (a.type.toLowerCase() > b.type.toLowerCase()) return 1;
                    return 0;
                }),
        };
    }

    handleFormSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e?.preventDefault();

        this.props.actions?.onCancel();
    };

    handleFormCancel = () => {
        this.props.actions?.onConfirm(this.state.selectedTagsSource, this.state.withCommentsSource);
        this.props.actions?.onCancel();
    };
    handleFormClear = () => {
        this.setState({ selectedTags: [], withComments: false }, () => {
            this.props.actions?.onConfirm(this.state.selectedTags, this.state.withComments);
        });
    };

    search = (name: string, value: string) => {
        this.setState({
            searchQuery: value,
            searchTags:
                value.length === 0
                    ? this.state.tags
                    : this.state.tags
                          .filter((tag: TagType) => {
                              return tag.label.toLocaleLowerCase().includes(value.toLocaleLowerCase());
                          })
                          .sort(function (a, b) {
                              if (a.type.toLowerCase() < b.type.toLowerCase()) return -1;
                              if (a.type.toLowerCase() > b.type.toLowerCase()) return 1;
                              return 0;
                          }),
        });
    };

    setWithComments = (name: string, value: boolean) => {
        this.setState(
            {
                withComments: value,
            },
            () => {
                this.props.actions?.onConfirm(this.state.selectedTags, this.state.withComments);
            }
        );
    };

    setTag = (id: number) => {
        this.setState(
            (prevState) => {
                const { selectedTags } = prevState;
                const isTagSelected = selectedTags.includes(id);

                const updatedTags = isTagSelected
                    ? selectedTags.filter((tag) => tag !== id) // Remove tag
                    : [...selectedTags, id]; // Add tag

                return { selectedTags: updatedTags };
            },
            () => {
                this.props.actions?.onConfirm(this.state.selectedTags, this.state.withComments);
            }
        );
    };

    render() {
        return (
            <>
                <Form onSubmit={this.handleFormSubmit} className="bg-white shadow p-4 w-full rounded">
                    <div id={`Drag-${this.props.id}`} className="flex justify-between mb-2 no-select ">
                        <div className="text-lg leading-6 font-bold">{translate('Search tags')} </div>
                        <div
                            onTouchEnd={this.handleFormCancel}
                            onClick={this.handleFormCancel}
                            className="cursor-pointer"
                        >
                            <Icon>
                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                <path d="M18 6l-12 12" />
                                <path d="M6 6l12 12" />
                            </Icon>
                        </div>
                    </div>
                    <div className="flex items-start justify-between mt-5">
                        <div>{translate('Select the user tag(s) you would serach for.')}</div>
                        <div>
                            <Input
                                onChange={this.search}
                                placeholder={translate('Enter tag name')}
                                name="search"
                                className="px-4 py-1 w-32 rounded-md text-md text-bold text-gray-300 border border-gray-300"
                            ></Input>
                        </div>
                    </div>
                    <div className=" w-full gap-2 mt-5">
                        <Scrollbars style={{ height: 150 }}>
                            {this.state.searchTags.map((tag: TagType) => {
                                return (
                                    <TypeTag
                                        className="mt-1 mr-1"
                                        active={this.state.selectedTags.includes(tag.id)}
                                        key={tag.id}
                                        type={tag.type}
                                        onClick={() => {
                                            this.setTag(tag.id);
                                        }}
                                    >
                                        {tag.label}
                                    </TypeTag>
                                );
                            })}
                        </Scrollbars>
                    </div>
                    <div className="mt-5 flex items-center gap-1">
                        <div className="flex items-center align-middle">
                            <ToggleButton
                                value={this.state.withComments}
                                onChange={this.setWithComments}
                                name="withComments"
                            ></ToggleButton>
                        </div>
                        <div className="flex items-center gap-2  ">
                            <div>{translate('Find all transits with comments')}</div>
                        </div>
                    </div>

                    <div className="flex justify-end items-center ">
                        <div className="mt-5 flex gap-3">
                            <Button
                                className="px-4 py-2 font-bold border border-gray-400"
                                onClick={this.handleFormCancel}
                            >
                                {translate('Cancel')}
                            </Button>
                            <Button
                                className="px-4 py-2 font-bold border border-gray-400"
                                onClick={this.handleFormClear}
                            >
                                {translate('Clear')}
                            </Button>
                            <Button type="submit" className="px-4 py-2 bg-primary-submit rounded-md text-white">
                                {translate('Save')}
                            </Button>
                        </div>
                    </div>
                </Form>
            </>
        );
    }
}

const searchTagsModelStateToProps = (state: RootState) => ({
    language: state.user.user.language,
    tags: state.port.tags,
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const searchTagsModelDispatchToProps = () => ({});

export default connect(searchTagsModelStateToProps, searchTagsModelDispatchToProps)(SearchTagsModel);
